const menu = [
    {
        route: '/',
        name: 'Home',
        icon: 'home',
        color: 'primary',
        icon_color: 'white',
        child: []
    },
    {
        route: '/profilku',
        name: 'Profilku',
        icon: 'account_circle',
        color: 'primary',
        icon_color: 'white',
        child: []
    },
    {
        route: '',
        name: 'Riwayat Pegawai',
        icon: 'account_box',
        color: 'green',
        child: [
            {
                route: '/biodataPegawai',
                name: 'Biodata Pegawai',
                icon: 'home',
                color: 'light-blue',
                icon_color: 'white',
                child: []
            },
            {
                route: '/kartuPegawai',
                name: 'Kartu Pegawai',
                icon: 'home',
                color: 'light-blue',
                icon_color: 'white',
                child: []
            },
            {
                route: '/skpPegawai',
                name: 'SKP Pegawai',
                icon: 'home',
                color: 'light-blue',
                icon_color: 'white',
                child: []
            },

            {
                route: '',
                name: 'Riwayat Kepangkatan / Jabatan',
                icon: 'home',
                color: 'light-blue',
                icon_color: 'white',
                child: [
                    {
                        route: '/skPengangkatan',
                        name: 'SK Pengangkatan',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/kepangkatan',
                        name: 'Kepangkatan',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/jabatanStruktural',
                        name: 'Jabatan Struktural',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/jabatanFungsional',
                        name: 'Jabatan Fungsional',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                ]
            },

            {
                route: '',
                name: 'Data Keluarga',
                icon: 'radio_button_checked',
                color: 'light-blue',
                icon_color: 'white',
                child: [
                    {
                        route: '/dataSuamiIstri',
                        name: 'Data Suami/Istri',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/dataAnak',
                        name: 'Data Anak',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },

                ]
            },

            {
                route: '',
                name: 'Riwayat Pendidikan',
                icon: 'radio_button_checked',
                color: 'light-blue',
                icon_color: 'white',
                child: [
                    {
                        route: '/pendidikanFormal',
                        name: 'Riwayat Pendidikan Formal',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/diklatFungsional',
                        name: 'Riwayat Diklat Fungsional',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/diklatStruktural',
                        name: 'Riwayat Diklat Struktural',
                        icon: 'home',
                        color: 'light-blue',
                        icon_color: 'white',
                        child: []
                    },

                ]
            },

        ]
    },


    {
        route: '/',
        name: 'Monitoring',
        icon: 'assignment',
        color: 'light-blue',
        icon_color: 'white',
        child: [
            {
                route: '/Mon_daftarUrut',
                name: 'Daftar Urut',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: []
            },
            {
                route: '/Mon_strukturOrganisasi',
                name: 'Struktur Organisasi',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: []
            },
            {
                route: '/Mon_pejabat',
                name: 'Pejabat',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: []
            },
        ]
    },

    {
        route: '/',
        name: 'Data Master',
        icon: 'settings',
        color: 'deep-orange',
        icon_color: 'white',
        child: [
            {
                route: '/Mon_daftarUrut',
                name: 'Master Jabatan',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: [
                    {
                        route: '/masterJenisJabatan',
                        name: 'Jenis Jabatan',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/masterKelasJabatan',
                        name: 'Kategori Jabatan',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/masterJabatan',
                        name: 'Nama Jabatan',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                ]
            },

            {
                route: '/',
                name: 'Auth',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: [
                    {
                        route: '/menuList',
                        name: 'List Menu',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/klpUsers',
                        name: 'Klp User',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                    {
                        route: '/register',
                        name: 'Register',
                        icon: 'home',
                        color: 'primary',
                        icon_color: 'white',
                        child: []
                    },
                ]
            },

            {
                route: '/masterPangkatGolongan',
                name: 'Master Pangkat/Golongan',
                icon: 'home',
                color: 'primary',
                icon_color: 'white',
                child: []
            },
        ]
    },

];



module.exports = {
    menu: menu,

}